<template>
  <div>
    <div :class="$style.field">
      <div :class="$style.left" v-if="type === 1 ? true : false">
        <img :class="$style.icon" :src="pic" alt />
      </div>
      <div :class="[$style.left, $style.info]" v-if="type === 2 ? true : false">{{info + " :"}}</div>
      <input
        :disabled="disabled"
        :type="inputType"
        :placeholder="placeHolder"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
      <div :class="$style.right" v-if="type === 1 ? false : true" @click="showPopup">
        <img :src="pull" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { CDN_URL } from "@/config";

export default {
  props: {
    index: { // 序号
      type: Number,
      default: 0
    },
    type: { // 类型
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    },
    pic: { 
      type: String
    },
    info: {
      type: String
    },
    placeHolder: {
      type: String,
      default: ""
    },
    inputType: {
      type: String,
      default: "text"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      pull: `${CDN_URL}/packet/pull-down.png`,
      
    };
  },
  methods: {
    showPopup() {
      this.$emit("showPopup", this.index);
    }
  }
};
</script>

<style lang="scss" module>
.field {
  width: 226px;
  height: 42px;
  background: rgba(241, 241, 241, 1);
  border-radius: 9px;
  position: relative;
  .left {
    width: 52px;
    height: 42px;
    // background-color: black;
    position: absolute;
    left: 0;
    top: 0;
    border-top-left-radius: 9px;
    border-bottom-left-radius: 9px;
    .icon {
      width: 20px;
      position: absolute;
      left: 14px;
      top: 7px;
    }
  }
  .info {
    background-color: #ffce64;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: 42px;
  }
  > input {
    width: 141px;
    height: 42px;
    position: absolute;
    left: 52px;
    top: 0;
    padding: 0px 10px;
    background: rgba(241, 241, 241, 1);
    &::-webkit-input-placeholder {
      color: #c0c0c0;
      line-height: 24px;
    }
  }
  .right {
    width: 33px;
    height: 42px;
    position: absolute;
    right: 0;
    top: 0;
    // background-color: black;
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
    > img {
      width: 16px;
      position: absolute;
      left: 8px;
      top: 15px;
    }
  }
}
</style>